import { Component, OnDestroy, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { Router } from '@angular/router';
import 'rxjs';
import { DBService } from '../../service';
import { DownLoadService } from '../download';
import { AuthService } from '../../service';
import { User } from '../../model/types';
import { AnalysisKey, PreviousAnalysis, PreviousAnalysisData } from '../../model/analysis-details.model';
import { DropDownService } from '../../service/drop-down.service';
import Utils from '../../utility/Utils';
import { AppLoaderService } from '../../service/app-loader/app-loader.service'

@Component({
    selector: 'app-previous-analysis',
    templateUrl: './previous-analysis.component.html',
    styleUrls: ['./previous-analysis.component.scss'],
    standalone: false
})
export class PreviousAnalysisComponent implements OnInit, OnDestroy {

    pageTitle = 'Previous Activities';
    signedInUser: any;
    previousAnalysisKeys: AnalysisKey[] = [];
    pageLoaded = false;
    errorMessage: string = '';
    isLoading: boolean = false;
    displayErrorMessage: boolean = false;


    constructor(private _sharedService: SharedService,
        private authService: AuthService,
        private router: Router,
        private dbService: DBService,
        private dropDownService: DropDownService,
        private downloadService: DownLoadService,
        private loader: AppLoaderService,) {
        this._sharedService.emitChange(this.pageTitle);

    }

    openDialog() {
        this.loader.open();
    }


    ngOnInit(): void {
        this.pageLoaded = true;
        this.authService.getCurrentUser((err, user: User) => {
            this.signedInUser = user;
            if (!this.signedInUser || !this.signedInUser.signedIn) {
                this.router.navigate(['/extra-layout/signin']);
                return;
            } else {
                this.dbService.getUserAnalysis(this.signedInUser.username).subscribe({
                    next: (data: PreviousAnalysisData) => {
                        const util = new Utils(this.dropDownService.nameDescMap)
                        this.previousAnalysisKeys = util.restructureSearch(data.data);
                        this.pageLoaded = false;
                        this.displayErrorMessage = false;
                        // if(this.pageLoaded==true){
                        //     this.closeDialog()
                        //   }
                    },
                    error: (err) => {
                        this.pageLoaded = false;
                        this.displayErrorMessage = true;
                        switch (err.status) {
                            case 400:
                                this.errorMessage = "Bad Request. Please verify the input values.";
                                break;
                            case 401:
                                this.errorMessage = "Unauthorized access. Please login again.";
                                break;
                            case 403:
                                this.errorMessage = "Access denied. You do not have permission to perform this action.";
                                break;
                            case 404:
                                this.errorMessage = "No data found for the given criteria.";
                                break;
                            case 500:
                                this.errorMessage = "Server error. Please try again later.";
                                break;
                            case 502:
                                this.errorMessage = "Bad Gateway. The server is temporarily unavailable.";
                                break;
                            case 503:
                                this.errorMessage = "Service Unavailable. Please try again later.";
                                break;
                            case 504:
                                this.errorMessage = "Gateway Timeout. Server took too long to respond.";
                                break;
                            default:
                                this.errorMessage = "Unexpected error occurred. Please try again.";
                        }
                    }

                });
            }
        });

        // this.dbService.userSearch.subscribe(
        //     (data: PreviousAnalysis[]) => {
        //         const util = new Utils(this.dropDownService.nameDescMap)
        //         this.previousAnalysisKeys = util.restructureSearch(data);
        //         this.pageLoaded = true;
        //         // if(this.pageLoaded==true){
        //         //     this.closeDialog()
        //         //   }
        //     }
        // );


    }
    closeDialog() {
        this.loader.close();
    }

    ngOnDestroy(): void {
    }

}
